import React, { useContext } from 'react';
import './styles/Footer.css';
import { NavLink } from 'react-router-dom';


import FooterMap from './FooterMap'
import FooterContactForm from './FooterContactForm';
import config from '../config/config';

import { ContactContext } from '../context/ContactContext';

const Footer = () => {
    const { contacts, loading, formatPhone } = useContext(ContactContext);

    return (
        <footer className="footer" role="contentinfo"> {/* ✅ Apply background dynamically */}
            <div className='footer-overlay'> {/* ✅ Dark overlay for readability */}
                <h2 id="footer-title" className="sr-only">Withrow Knives Footer</h2>
                <div className='footer-wrapper'>
                    <div className='footer-container'>
                        <div className='footer-content-wrapper'>
                            <div className='footer-content-columns-wrapper'>


                                {/* ✅ Quick Links */}
                                <div className='footer-content-column'>
                                    <div className='footer-content-column-header'>
                                        <h3><span>Quick Links</span></h3>
                                    </div>
                                    <div className="footer-links">
                                        <NavLink to="/shop-knives/all-knives">Shop All Knives</NavLink>
                                        <NavLink to="/about">About Us</NavLink>
                                        <NavLink to="/our-process">Our Process</NavLink>
                                        <NavLink to="/contact">Contact</NavLink>
                                        <span><NavLink to="/signup">Signup</NavLink> / <NavLink to="/login">Login</NavLink></span>
                                        
                                    </div>
                                    <div className='footer-content-column-header'>
                                        <h3><span>Policies & Resources</span></h3>
                                    </div>
                                    <div className="footer-links">
                                        <NavLink to="/shipping-returns">Shipping & Returns</NavLink>
                                        <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                                        <NavLink to="/terms-of-service">Terms of Service</NavLink>
                                    </div>
                                    <div className='back-to-top-button-wrapper'>
                                    <p>BACK TO TOP</p>
                                    <button 
                                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                                        className="back-to-top-btn"
                                        aria-label="Back to top"
                                    >
                                        <i className="fa-solid fa-chevron-up"></i>
                                        
                                    </button>
                                    
                                </div>
                                </div>
                                
                                {/* ✅ Contact Info */}
                                <div className="footer-content-column">
                                <div className="footer-content-column-header">
                                    <h3><span>Contact Us</span></h3>
                                </div>

                                <div className="footer-content-row-wrapper">
                                    <div className="footer-content-row">
                                    {loading ? (
                                        <p>Loading contact info...</p>
                                    ) : contacts.length === 0 ? (
                                            <p>
                                                <strong>Email:</strong>{" "}
                                                <a href={`mailto:${config.contactEmail}`}>
                                                {config.contactEmail}
                                                </a>
                                            </p>
                                    ) : (
                                        contacts.map((c) => (
                                        <div key={c.id} className="footer-contact-item">
                                            <p className="contact-name">{c.name}</p>

                                            {c.phone_display && (
                                            <p>
                                                <strong>Phone:</strong>{" "}
                                                <a href={`tel:${c.phone_raw}`}>
                                                {formatPhone(c.phone_raw)}
                                                </a>
                                            </p>
                                            )}

                                            {c.email && (
                                            <p>
                                                <strong>Email:</strong>{" "}
                                                <a href={`mailto:${c.email}`}>
                                                {c.email}
                                                </a>
                                            </p>
                                            )}
                                        </div>
                                        ))
                                    )}

                                    <br />
                                    <span>
                                        <strong>Contact Hours:</strong> Monday - Friday: 9 AM - 5 PM
                                    </span>

                                    <br /><br />
                                    <span><strong>Location:</strong></span>
                                    <address>
                                        West Virginia
                                        <FooterMap />
                                    </address>
                                    </div>
                                </div>
                                </div>

                                



                                
                                <div className='footer-content-column'>

                                </div>


                                {/* ✅ Contact Form */}
                                <div className='footer-content-column' role="form" aria-labelledby="contact-form-title">
                                    <div className='footer-content-column-header'>
                                        <h3 id="contact-form-title">Send Us a Message</h3>
                                    </div>
                                    <div className='footer-contact-form-wrapper'>
                                        <FooterContactForm />
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* ✅ Bottom Footer Section */}
                        <div className='footer-bottom-wrapper'>
                            <div className='footer-bottom-content-wrapper'>
                                <div className='footer-credit-wrapper'>
                                    <div className='footer-credit' aria-label="Copyright and site credits">
                                        <h3>
                                            <span>Copyright © 2024 Withrow Knives. All Rights Reserved.&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span><p>Website built and managed by &nbsp;<a href="https://www.wattswebworks.com" target="_blank" rel="noopener noreferrer" aria-label="WattsWebWorks, opens in a new tab">WattsWebWorks</a></p></span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
